<template>
  <div class="BgTile">
    <div v-if="locked" class="ribbon ribbon-top-right">
      <span>Professional</span>
    </div>
    <div class="BgTile__upper">
      <div class="BgTile__text">
        <div class="BgTile__title">
          {{ title }}
          <bg-tooltip
            v-if="tooltip"
            class="BgTile__tooltip"
            color="white"
            :info="true"
          >
            <template slot="content">{{ tooltip }}</template>
          </bg-tooltip>
        </div>
        <div class="BgTile__subtitle">{{ subTitle }}</div>
      </div>
      <div v-if="linkText && !locked" class="BgTile__link" @click="onNavigate">
        {{ linkText }}
        <bg-icon name="chevronRight" />
      </div>
    </div>
    <div v-if="!locked" class="BgTile__content">
      <slot />
    </div>
    <div v-else class="BgTile__locked">
      <bg-icon class="BgTile__locked-icon" name="brainrocket" />
      <bg-button
        class="bottom-btn"
        textColor="white"
        text="Upgrade"
        @click="openHelpCrunch"
      />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./style.scss";
</style>

<script>
import BgIcon from "@/components/bg-icon";
import BgButton from "@/components/bg-button";
import BgTooltip from "@/components/bg-tooltip";

import { mapState } from "vuex";
export default {
  name: "BgTile",
  components: {
    BgIcon,
    BgButton,
    BgTooltip,
  },
  props: {
    title: String,
    subTitle: String,
    linkUrl: String,
    linkText: String,
    locked: Boolean,
    tooltip: String,
  },
  computed: {
    ...mapState({
      testState: (state) => state.test,
    }),
  },
  methods: {
    onNavigate() {
      this.$router.push({ path: this.linkUrl });
    },
    openHelpCrunch() {
      HelpCrunch("openChat");
      HelpCrunch(
        "typeUserMessage",
        `Hello!  I would like to ask about upgrading essential test ${this.testState.name} from ${this.testState.company.name} to professional!`
      );
    },
  },
};
</script>
